export class PeppolInvoiceResponseConfig {
	SendOnApprove:boolean = false;
	SendOnCreatePurchase:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.SendOnApprove = data.SendOnApprove;
		this.SendOnCreatePurchase = data.SendOnCreatePurchase;
	}

	public getJSON(){
		return {
			SendOnApprove: this.SendOnApprove,
			SendOnCreatePurchase: this.SendOnCreatePurchase
		};
	}
}
